import { Controller } from "@hotwired/stimulus"
import { getSafeParams } from "@lib/utils"

export default class extends Controller {

  intervalId = null

  get scrollContainer() {
    return this.element.querySelector(".calendar-scrollable-container")
  }

  get timeMarker() {
    return this.element.querySelector(".time-marker")
  }

  calculateTimeValues() {
    const totalSlots = this.element.querySelectorAll(".time-slot").length
    const firstSlot = this.element.querySelector(".time-slot")
    const lastSlot = this.element.querySelector(".time-slot:last-child")

    const startTime = new Date(firstSlot.dataset.start.replace(/"/g, ""))
    const endTime = new Date(lastSlot.dataset.end.replace(/"/g, ""))

    const dayStartMinutes = startTime.getHours() * 60 + startTime.getMinutes()
    const dayEndMinutes = endTime.getHours() * 60 + endTime.getMinutes()
    const sinceMidnightMinutes = new Date().getHours() * 60 + new Date().getMinutes()

    const totalMinutes = dayEndMinutes - dayStartMinutes
    const elapsedMinutes = sinceMidnightMinutes - dayStartMinutes

    const elapsedRatio = elapsedMinutes / totalMinutes
    const dayComplete = elapsedRatio >= 1
    const offset = this.scrollContainer.scrollHeight * elapsedRatio

    return { elapsedRatio, dayComplete, offset }
  }

  // Update the position of the time marker
  updateTimeMarker() {
    if (!this.timeMarker) return

    const { offset } = this.calculateTimeValues()

    // Determine if the day is complete
    if (offset >= this.scrollContainer.scrollHeight) {
      this.timeMarker.classList.add("hidden")
      return
    }

    this.timeMarker.style.top = offset + "px"
    this.timeMarker.classList.remove("hidden")
  }

  scrollIntoView() {
    if (!this.timeMarker) return

    const { elapsedRatio, dayComplete, offset } = this.calculateTimeValues()

    const halfContainerHeight = this.scrollContainer.offsetHeight / 2
    const adjustedOffset = dayComplete ? offset : offset - halfContainerHeight

    this.scrollContainer.scrollTo({ top: adjustedOffset + 250, behavior: "smooth" })
  }

  setClinicLinkParams() {
    const params = getSafeParams(["date", "days", "view", "rm"])

    const dropdown = document.getElementById("calendar-clinic-dropdown")
    const items = dropdown.querySelectorAll("a.menu-item")

    items.forEach(item => {
      const base = item.href.split("?")[0];
      const url = new URL(base);
      url.search = new URLSearchParams(params).toString();
      item.href = url.toString();
    })
  }

  setModeLinkParams() {
    const params = getSafeParams(["date", "view"])

    const dropdown = document.getElementById("calendar-mode")
    const items = dropdown.querySelectorAll("a.menu-item")

    items.forEach(item => {
      const url = new URL(item.href);

      // Merge safe params into existing params
      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });

      item.href = url.toString();
    })
  }

  connect() {
    this.updateTimeMarker()
    this.scrollIntoView()
    this.setClinicLinkParams()
    this.setModeLinkParams()
    this.intervalId = setInterval(this.updateTimeMarker.bind(this), 60000)
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

}
